const breakpoints = {
	small: 400,
	mobileBreak: 480,
	mid: 600,
	frame: 1440
}

export default breakpoints;
